// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer-container-sNuYF"};